import { render, staticRenderFns } from "./gameDataCount.vue?vue&type=template&id=7d7b6ed8&"
import script from "./gameDataCount.vue?vue&type=script&lang=js&"
export * from "./gameDataCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d7b6ed8')) {
      api.createRecord('7d7b6ed8', component.options)
    } else {
      api.reload('7d7b6ed8', component.options)
    }
    module.hot.accept("./gameDataCount.vue?vue&type=template&id=7d7b6ed8&", function () {
      api.rerender('7d7b6ed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/gameDataCount.vue"
export default component.exports